import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';

import withModal from '../../../../lib/hoc/withModal';
import { setTrim } from '../../../../lib/common';
import { appActions } from '../../../../store/modules/app';
import GenerateCouponValidSuccessModal from '../../../../views/app/common/modal/GenerateCouponValidSuccessModal';

/**
 *  쿠폰 발급 유효 체크 성공 모달
 */
class GenerateCouponValidSuccessModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  알림톡 발송 여부
       */
      isSendAlimtalk: false,
      /**
       *  메모
       */
      memo: null,
    };
  }

  /**
   *  쿠폰 발급
   */
  onSubmit = () => {
    const { generateCoupon, data } = this.props;
    const { isSendAlimtalk, memo } = this.state;
    const { userCouponList, targetAction } = data;

    /**
     *  쿠폰 발급하기
     */
    generateCoupon({
      targetAction,
      userCouponList,
      isSendAlimtalk,
      memo: setTrim(memo),
    });

    /**
     *  모달 닫기
     */
    this.closeModal();
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.appToggleModal({
      name: 'generateCouponValidSuccessModal',
      value: false,
    });
  };

  render() {
    const { isOpen, data, form } = this.props;
    const { isSendAlimtalk, memo } = this.state;

    return (
      <GenerateCouponValidSuccessModal
        isOpen={isOpen}
        data={data}
        form={form}
        isSendAlimtalk={isSendAlimtalk}
        memo={memo}
        setData={this.setData}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.generateCouponValidSuccessModal.isOpen,
    data: state.app.generateCouponValidSuccessModal.data,
  };
};

const mapDispatchToProps = {
  generateCoupon: appActions.generateCoupon,
  appToggleModal: appActions.appToggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(withModal()(GenerateCouponValidSuccessModalContainer)));
